import moment from 'moment-timezone';
import { api } from '@/f1/service';
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Language from './language';


const _i18n_data = {
  fields: {
    EN : () => this.fields_en,
    KO : () => this.fields_ko,
  },
  password: {
    EN : () => `Password required.`,
    KO : () => `비밀번호를 입력하세요.`,
  }
};


export default {
  components: { vueDropzone, Language },
  data: () => {
    return {
      file : undefined,
      files:[],
    }
  },
  computed: {
    i18n_data() { return _i18n_data; },
    fields_en() {
      return [
        { key: 'index', label: 'No.', sortable: false, thStyle: 'width: 5%' },
        { key: 'name', label: 'File name', sortable: true, thStyle: 'width: 30%'},
        { key: 'description', label: 'Description', sortable: false },
        { key: 'size', label: 'Size', sortable: true, thStyle: 'width: 10%' },
        { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%' },
      ]
    },
    fields_ko() {
      return [
        { key: 'index', label: 'No.', sortable: false, thStyle: 'width: 5%' },
        { key: 'name', label: '파일 이름', sortable: true, thStyle: 'width: 30%'},
        { key: 'description', label: '설명', sortable: false },
        { key: 'size', label: '크기', sortable: true, thStyle: 'width: 10%' },
        { key: 'func', label: '더보기', sortable: false, thStyle: 'width: 10%' },
      ]
    },
    startRow : function() {
      return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
    }
  },
  methods: {
    async bs_file(file) {
      let fr = new FileReader();
      let f = file.target.files[0];
      if(!f) { return; }
      if(f.size > 5242880) { this.$toastr.w('Maximum file size'); return; }
      if(f.size == 0) { this.$toastr.e('File Size 0'); return;}
      fr.onload = () => {
        let model = Object.assign(
          this.file,
          { 'content' : fr.result, 'description' : ''},
          { 'path' : this.file.name, 'index' : this.files.length }
          );
        this.files.push(model);
      }
      fr.readAsDataURL(f);
    },
    async send(i) {
      let f = JSON.parse(JSON.stringify(this.files[i]))
      location.hostname == 'localhost' ?  console.info(f) : '';
      try {
        let rs = await api.wsfinder.WSFinder_Call('report', 'insert', f)
        if(!rs.error) {
          this.remove(i); this.$toastr.s('Report reception');
        } else {
          this.$toastr.s('Report', "failed");
        }
        this.$emit('refresh')

      }catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText)  }
    },
    remove(i) { this.files.splice(i, 1); this.refresh();},
    reset() { this.files = []; this.refresh(); },
    refresh() { console.log('refresh'); this.$refs._list.refresh();},
  },
  created: function() {   console.log('report.list.vue', 'created'); },
  destroyed: function() { console.log('report.list.vue', 'destroyed'); },
  mounted: function() { console.log('report.list.vue', 'mounted'); },
}
